import GLightbox from '../../node_modules/glightbox/dist/js/glightbox.js';
require('../../node_modules/glightbox/dist/css/glightbox.css');

document.addEventListener('DOMContentLoaded', () => {
    window.lightboxes = () => {
        if(document.querySelectorAll('.js-glightbox').length) {
            const lightbox = GLightbox({
                selector: '.js-glightbox',
                draggable: false,
                height: '590px'
            });

            lightbox.on('slide_after_load', (data) => {
                const { slideIndex, slideNode, slideConfig, player, trigger } = data;
                if(slideNode.querySelector('form#offer-contact-form')) {

                    const checkbox01 = slideNode.querySelector('[name="agreement01"]');
                    checkbox01.id = `agreement01${slideIndex}`;
                    checkbox01.parentElement.setAttribute('for', `agreement01${slideIndex}`);

                    const checkbox02 = slideNode.querySelector('[name="agreement02"]');
                    checkbox02.id = `agreement02${slideIndex}`;
                    checkbox02.parentElement.setAttribute('for', `agreement02${slideIndex}`);

                    //reload recaptcha
                    if(grecaptcha) {
                        const widget = document.querySelector('#glightbox-slider .g-recaptcha');
                        grecaptcha.render(widget,{
                            'sitekey' : widget.getAttribute('data-sitekey'),
                            'size' : widget.getAttribute('data-size'),
                            'theme' : widget.getAttribute('data-theme'),
                            'type' : widget.getAttribute('data-type')
                        });
                    }

                    window.offerForm();
                }
            });

            window.lightbox = lightbox;

        }

        if (document.querySelectorAll("[href*='youtu']").length > 0) {
            const video = GLightbox({
                selector: ".js-video"
            });
        }
    }
}, false);
